module.exports = __webpack_public_path__ + "static/img/yk6120.29c1c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hardware/yk6120.png
// module id = xHI9
// module chunks = 1